// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "loader__spinner-16G9E";
export { _1 as "__esModule", _2 as "loader__spinner" }
export default { "__esModule": _1, "loader__spinner": _2 }
